class productByob extends HTMLElement {
    constructor() {
        super();

        this.productWrapperSelector = '[js-product-wrapper]';
        this.addToSetBtn = '[js-ats-btn]';
        this.addQtysBtn = '[js-qty-btn]';
        this.incrementBtnSelector = '[js-quantity-increment]';
        this.decrementBtnSelector = '[js-quantity-decrement]';
        this.quantityInputSelector = '[js-quantity-input]';
        this.productBundleCountBadge = '[js-product-bundle-count]';

        this.selectionCountWrapper = this.querySelector('[js-bundle-selection-count-wrap]');
        this.selectionCount = this.querySelector('[js-selection-count]');
        this.addToCartBtn = this.querySelector('[js-bundle-addToCart-btn]');
        this.sellingPlanSelect = this.querySelector('[js-byob-custom-option-select]');
        this.totalPrice = this.querySelectorAll('[js-total-price]');
        this.totalDiscountedPrice = this.querySelectorAll('[js-total-discounted-price]');
        this.currencyFormat = this.querySelector('[currency-format]').getAttribute('currency-format');
        this.oneTimePrice = this.querySelector('[onetime-price]').getAttribute('onetime-price');
        this.oneTimeStrikePrice = this.querySelector('[onetime-strike-price]').getAttribute('onetime-strike-price');
        this.subsciptionPrice = this.querySelector('[subsciption-price]').getAttribute('subsciption-price');
        this.subsciptionStrikePrice = this.querySelector('[subscription-strike-price]').getAttribute('subscription-strike-price');

        this.subscriptionDiscountedPriceEls = this.querySelectorAll('[js-skio-subsciption-discounded-price]');
        this.subscriptionTotalPriceEls = this.querySelectorAll('[js-skio-subsciption-total-price]');
        this.oneTimeTotalPriceEls = this.querySelectorAll('[js-skio-one-time-total-price]');

        this.products = [];
        this.sellingPlanId = this.sellingPlanSelect.value;
        this.sellingPlanName = null;
        this.servings = parseInt(this.querySelector('[js-onetime-per-serving]').getAttribute('data-serving-value')) || 0;

        this.oneTimeRadio = this.querySelector('[js-skio-bundle-onetime]');
        this.subscriptionRadio = this.querySelector('[js-skio-bundle-subscription]');
        this.selectField = this.querySelector('[js-skio-bundle-select-field]');

        this.selectionCount.innerHTML = skioDynamicBundleMinLimit;

        this.handleSubscriptionToggle();

        document.addEventListener('skioBundlePrice:init', () => {
            this.updatePrice();
            this.selectionCount.innerHTML = skioDynamicBundleMinLimit;
        });

        this.addEventListener('click', (event) => {
            
            this.querySelectorAll(this.addToSetBtn).forEach(addToSet => {
                if (addToSet.contains(event.target)) {
                    const parent = addToSet.closest(this.productWrapperSelector);
                    const quantityField = parent.querySelector(this.quantityInputSelector);
                    quantityField.stepUp();
                    parent.classList.add('selected');
                    this.addProductToBox(parent);
                    this.updatePrice();
                }
            });

            this.querySelectorAll(this.incrementBtnSelector).forEach(incrementBtn => {
                if (incrementBtn.contains(event.target)) {
                    const parent = incrementBtn.closest(this.productWrapperSelector);
                    const quantityField = parent.querySelector(this.quantityInputSelector);
                    quantityField.stepUp();

                    this.addProductToBox(parent);
                    this.updatePrice();
                }
            });

            this.querySelectorAll(this.decrementBtnSelector).forEach(decrementBtn => {
                if (decrementBtn.contains(event.target)) {
                    const parent = decrementBtn.closest(this.productWrapperSelector);
                    const currentProductId = Number(parent.dataset.productId);
                    const quantityField = parent.querySelector(this.quantityInputSelector);

                    if (Number(quantityField.value) > 0) {
                        quantityField.stepDown();
                    }

                    this.removeProductFromBox(currentProductId, parent);
                    this.updatePrice();
                }
            });

            this.sellingPlanId = this.sellingPlanSelect.value;
            if (this.sellingPlanSelect) {
                const initialOption = this.sellingPlanSelect.options[this.sellingPlanSelect.selectedIndex];
                this.sellingPlanName = initialOption?.getAttribute('data-plan-name') || null;
            }
        });
        

        this.sellingPlanSelect.addEventListener('change', (e) => {
            this.sellingPlanId = e.currentTarget.value;
            this.updatePrice();
            const selectedOption = e.target.options[e.target.selectedIndex];
            this.sellingPlanName = selectedOption.getAttribute('data-plan-name');
        });

        this.addToCartBtn.addEventListener('click', () => {
            let cartItems = [];

            this.products.forEach(product => {
                const itemFound = cartItems.find(item => item.id === product.id);
                if (itemFound) {
                    cartItems = cartItems.map(item => {
                        if (item.id === product.id) {
                            item.quantity += product.quantity;
                        }
                        return item;
                    });
                } else {
                    cartItems.push({
                        quantity: product.quantity,
                        id: product.id,
                        selling_plan: this.subscriptionRadio?.checked ? this.sellingPlanId : null,
                        properties: {
                            _dynamicBoxIndex: new Date().getTime(),
                            _dynamicBoxId: skioDynamicBoxId,
                            _sellingPlanName:this.subscriptionRadio?.checked ? this.sellingPlanName : null,
                            _productUrl: this.getAttribute('data-product-url'),
                            _discountedPrice: this.totalDiscountedPrice[0].innerText.replace('CAD', '').replace('USD', ''),
                            _originalPrice: this.totalPrice[0].innerText,
                        }
                    });
                }
            });

            console.log({ cartItems })

            this.addToCartBtn.classList.add('loading');
            this.addToCartBtn.querySelector('.loading__spinner')?.classList.remove('hidden');
            this.addToCart(cartItems);
        });
    }

    updateServing(packSize){
        const servingElements = this.querySelectorAll('[js-skio-dynamic-bundle-serving]');
        servingElements.forEach(element => {
            element.innerText = this.servings * packSize;
        });
    }

    updateEachItemPriceInProgressBar(){  
        skioDynamicBundlesizeInterval.forEach(size => {
            const sizeTag = this.querySelector(`[js-bundle-pregress-bar-each-item-price][data-pack="${size}"]`);
            if(sizeTag) {
                 if (this.subscriptionRadio?.checked) {
                    sizeTag.innerText = `$${(skioDynamicBundlePrices[size]?.subscription.discountedPrice / size).toFixed(2)}`;
                 } else {
                    sizeTag.innerText = `$${(skioDynamicBundlePrices[size]?.oneTime.discountedPrice / size).toFixed(2)}`;
                 }
            }
        })
    }
    
    updatePrice() {
        const packSize = this.products?.length > skioDynamicBundleMinLimit ? this.products.length : skioDynamicBundleMinLimit;

        this.subscriptionDiscountedPriceEls.forEach(subscriptionDiscountedPriceEl=>{
            subscriptionDiscountedPriceEl.innerText = `$${(skioDynamicBundlePrices[packSize]?.subscription.discountedPrice / packSize).toFixed(2)} ${this.currencyFormat}/${this.getAttribute('data-each-pack-text')}`;
        })
        this.subscriptionTotalPriceEls.forEach(subscriptionTotalPriceEl=>{
            subscriptionTotalPriceEl.innerText = `$${parseFloat(skioDynamicBundleVariantPrice).toFixed(2)} `
        })
        this.oneTimeTotalPriceEls.forEach(oneTimeTotalPriceEl=>{
            oneTimeTotalPriceEl.innerHTML = `<span>$${(skioDynamicBundlePrices[packSize]?.oneTime.discountedPrice / packSize).toFixed(2)} ${this.currencyFormat}/${this.getAttribute('data-each-pack-text')}</span>
            <s>$${parseFloat(skioDynamicBundleVariantPrice).toFixed(2)} </s>`
        })

        this.updateAddToCartButtonPrice(packSize);

        const subscriptionOrignalPrice = parseFloat(skioDynamicBundlePrices[packSize]?.subscription.originalPrice).toFixed(2);
        const subscriptionDiscoundedPrice = parseFloat(skioDynamicBundlePrices[packSize]?.subscription.discountedPrice).toFixed(2);
        const subscriptionDiscoundedAmount = subscriptionOrignalPrice - subscriptionDiscoundedPrice;

        const skioBundleOfferSavePriceEle = this.querySelector('[js-skio-bundle-offer-save-price]');
        skioBundleOfferSavePriceEle.innerHTML = `$${subscriptionDiscoundedAmount.toFixed(2)}`;

        this.updateServing(packSize);
        this.updateEachItemPriceInProgressBar();

        const oneTimePerServingTag = this.querySelector('[js-onetime-per-serving]');
        oneTimePerServingTag.innerText = `$${(skioDynamicBundlePrices[packSize]?.oneTime.discountedPrice / (this.servings * packSize)).toFixed(2)}`;

        const subscriptionPerServingTag = this.querySelector('[js-subscription-per-serving]');
        subscriptionPerServingTag.innerText = `$${(skioDynamicBundlePrices[packSize]?.subscription.discountedPrice / (this.servings * packSize)).toFixed(2)}`;

        document.querySelector('[js-byob-servings]').style.opacity = 1;

        if(this.querySelector('[js-skio-subscription-recurring-discount]')) {
            this.querySelector('[js-skio-subscription-recurring-discount]').innerText = `$${skioSubscriptionRecurringDiscountTier[packSize]}`;
        }
    }

    updateAddToCartButtonPrice(packSize) { 
        if (this.subscriptionRadio?.checked) {

            this.totalPrice.forEach(price=>{
                price.innerText = `$${parseFloat(skioDynamicBundlePrices[packSize]?.subscription.originalPrice).toFixed(2)} `;
            });

            this.totalDiscountedPrice.forEach(discoundPrice => {
                discoundPrice.innerText = `$${parseFloat(skioDynamicBundlePrices[packSize]?.subscription.discountedPrice).toFixed(2)} ${this.currencyFormat}`;
            }); 

        } else {

            this.totalPrice.forEach(price=>{
                price.innerText = `$${parseFloat(skioDynamicBundlePrices[packSize]?.oneTime.originalPrice).toFixed(2)} `;
            });

            this.totalDiscountedPrice.forEach(discoundPrice => {
                discoundPrice.innerText = `$${parseFloat(skioDynamicBundlePrices[packSize]?.oneTime.discountedPrice).toFixed(2)} ${this.currencyFormat}`;
            });

        }
    }

    addProductToBox(parent) {
        const imageUrl = parent.dataset.productImageUrl;
        const variantId = Number(parent.dataset.variantId);
        const productId = Number(parent.dataset.productId);
        const title = parent.dataset.productTitle;
        const price = Number(parent.dataset.productPrice);
        const customPrice = Number(parent.dataset.productCustomPrice) || 0;

        this.products.push({
            id: variantId,
            productId: productId,
            imageUrl,
            title,
            price,
            customPrice,
            quantity: 1,
        });

        this.updateStatus();
    }
    removeProductFromBox(id, parent) {
        const otherProducts = this.products.filter(product => product.productId !== id);
        const currentProducts = this.products.filter(product => product.productId == id);
        currentProducts.splice(0, 1);

        if (currentProducts.length === 0) {
            parent.classList.remove('selected');
        }

        this.products = [...currentProducts, ...otherProducts];
        this.updateStatus();
    }
    updateStatus() {
        if (this.products.length >= skioDynamicBundleMinLimit) {
            this.addToCartBtn.classList.remove('hidden');
            this.selectionCountWrapper.classList.add('hidden');
        } else {
            this.addToCartBtn.classList.add('hidden');
            this.selectionCountWrapper.classList.remove('hidden');
        }
        if (this.products.length >= skioDynamicBundleMaxLimit) {
            this.querySelectorAll(this.incrementBtnSelector).forEach(item => item.classList.add('disabled'));
            this.querySelectorAll(this.addToSetBtn).forEach(item => item.classList.add('disabled'));
        } else {
            this.querySelectorAll(this.incrementBtnSelector).forEach(item => item.classList.remove('disabled'));
            this.querySelectorAll(this.addToSetBtn).forEach(item => item.classList.remove('disabled'));
        }
        const productCount = this.products.length;

        this.progressBars = this.querySelectorAll('[js-progress-bar-pack]')
        this.progressBars.forEach((bar) => {
            const pack = parseInt(bar.dataset.pack);
            if (pack <= productCount) {
                bar.classList.add('selected');
            } else {
                bar.classList.remove('selected');
            }
        });

        const selectedPacks = this.querySelectorAll('[js-progress-bar-pack].selected');
       
        if(selectedPacks.length) {
            const index = parseInt(selectedPacks[selectedPacks.length - 1]?.getAttribute('data-index'));
            this.querySelector('[js-bundle-progress-bar-value]').style.width = `${index * 50}%`;
        }
        this.selectionCount.innerHTML = `${skioDynamicBundleMinLimit - this.products.length}`;
    }
    updateProductCountBadge(parent) {
        const quantityField = parent.querySelector(this.quantityInputSelector);
        const badge = parent.querySelector(this.productBundleCountBadge);
        const qty = Number(quantityField.value);

        if (qty >= 1) {
            badge.classList.remove('hidden');
            badge.innerText = qty;
        } else {
            badge.classList.add('hidden');
            badge.innerText = 0;
        }
    }
    handleSubscriptionToggle() {
        if (!this.oneTimeRadio || !this.subscriptionRadio || !this.selectField) return;

        const toggleVisibility = () => {
            if (this.subscriptionRadio.checked) {
                this.selectField.style.maxHeight = "1000px";
                this.selectField.style.opacity = "1";
                this.selectField.style.visibility = "visible";

            } else if (this.oneTimeRadio.checked) {
                this.selectField.style.maxHeight = "0px";
                this.selectField.style.opacity = "0";
                this.selectField.style.visibility = "hidden";
            }
            if(skioDynamicBundleMinLimit){
                setTimeout(() => {
                    this.updatePrice();
                }, 500);
            }
        }; 

        toggleVisibility();
        this.oneTimeRadio.addEventListener("change", toggleVisibility);
        this.subscriptionRadio.addEventListener("change", toggleVisibility);
    }
    async addToCart(products) {
        const requestBody = { items: products };

        try {
            const resp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: 'POST',
                body: JSON.stringify(requestBody),
                headers: { "Content-Type": "application/json" },
            });

            const data = await resp.json();

            document.dispatchEvent(new CustomEvent("cart:refresh"));
            if (document.getElementById('Cart-Drawer')) {
                document.body.classList.add('open-cc', 'open-cart');
                document.getElementById('Cart-Drawer').classList.add('active');
            }

            this.addToCartBtn.classList.remove('loading');
            this.addToCartBtn.querySelector('.loading__spinner')?.classList.add('hidden');
        } catch (err) {
            console.error({ err });
        }
    }
}

customElements.define('product-byob', productByob);